<template>
  <q-dialog
    id="lockup-modal"
    ref="lockupModal"
    :content-css="{minWidth: '30vw', minHeight: '45vh'}"
    :content-classes="{ 'animated shake': invalidForm}"
    no-esc-dismiss
    no-backdrop-dismiss
    enter-class="bounceInUp"
    leave-class="bounceOutDown">
    <q-layout>
      <q-toolbar slot="header">
        <div class="q-toolbar-title">
          <q-icon name="lock"/>  <translate>LOCKUP</translate>
        </div>
      </q-toolbar>
      <div class="row full-height main">
        <div class="row col-12">
          <div class="col-12 flex justify-center items-center">
            <img
              src="https://s3.amazonaws.com/uifaces/faces/twitter/popey/128.jpg"
              class="inline-block avatar">
          </div>
          <div class="col-12 flex justify-center items-center">
            {{ user.name }}
          </div>
        </div>
        <div class="column col-12">
          <jt-form ref="form">
            <jt-input
              :float-label="$gettext('EMAIL')"
              v-model="user.dsLogin"
              type="text"
              class="col-12"
              name="email"
              disable
              readonly/>
            <jt-input
              :float-label="$gettext('PASSWORD')"
              v-model="user.password"
              type="password"
              class="col-12"
              name="password"
              required/>
          </jt-form>
        </div>
        <div class="row col-12 justify-center items-center buttons-container">
          <div class="col-12">
            <q-btn
              class="full-width"
              color="primary"
              @click="loginClickHandler">
              <translate>LOGIN</translate>
            </q-btn>
          </div>
        </div>
      </div>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { QBtn, QIcon, QDialog, QLayout, QToolbar } from 'quasar'
import { JtForm, JtInput } from 'jtech-webcomps'
@Component({
  components: { QDialog, QLayout, QToolbar, QBtn, QIcon, JtForm, JtInput },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          avatar: '',
          name: '',
          dsLogin: '',
          password: ''
        }
      }
    }
  }
})
export default class LockupModal extends Vue {
  invalidForm = false
  open () {
    this.$refs.lockupModal.show()
  }

  close () {
    this.$refs.lockupModal.hide()
  }

  onClose () {
    this.$emit('close')
  }

  onOpen () {
    this.$emit('open')
  }

  loginClickHandler () {
    this.validSettings ? this.hide() : (this.invalidForm = true)
  }

  get validSettings () {
    return !!(this.user.dsLogin && this.user.password)
  }

  @Watch('invalidForm')
  invalidFormChangeHandler () {
    setTimeout(() => {
      this.invalidForm = false
    }, 1000)
  }
}
</script>
<style lang="stylus" scoped>
  #lockup-modal {
    .modal-content {
      .main {
        overflow hidden
        padding 5px
        .avatar {
          width 128px
          height 128px
        }
      }
      .buttons-container {
        div {
           padding 3px
        }
      }
    }
  }
</style>
